import React from 'react';
import Layout from '../components/Layout/Layout';
import { Link } from 'react-router-dom';

const NAACReportsPage = () => {
  const reports = [
    { title: 'Self Study Report (SSR)', path: '/naac-ssr' },
    { title: 'Audit Report', path: '/naac-audit-report' },
    { title: 'AISHE Report', path: '/naac-aishe-report' },
    { title: 'University Affiliation', path: '/naac-university-affiliation' },
    { title: 'NAAC Certificate', path: '/naac-certificate' }
  ];

  return (
    <Layout>
      <div id="naac-reports" className="page-container" style={{ backgroundColor: '#fff', minHeight: '100vh', padding: '40px 0' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 20px' }}>
          
          <div style={{ 
            backgroundColor: '#fff', 
            padding: '40px', 
            borderRadius: '12px',
            boxShadow: '0 4px 25px rgba(0,0,0,0.1)',
            border: '1px solid #eee'
          }}>
            <h2 style={{ color: '#004488', borderBottom: '2px solid #add8e6', paddingBottom: '10px', marginBottom: '30px', fontSize: '2.2rem', fontWeight: 'bold', display: 'inline-block' }}>
              NAAC Reports Gallery
            </h2>

            <div style={{ 
              backgroundColor: '#333', 
              padding: '30px', 
              borderRadius: '8px',
              borderLeft: '5px solid #007bff',
              boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
            }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
                gap: '20px'
              }}>
                {reports.map((report, index) => (
                  <Link key={index} to={report.path} style={{
                    backgroundColor: '#1a1a1a',
                    padding: '25px 20px',
                    borderRadius: '8px',
                    border: '1px solid #444',
                    textDecoration: 'none',
                    textAlign: 'center',
                    transition: 'transform 0.2s, background-color 0.2s',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '120px'
                  }}>
                    <span style={{ color: '#e0e0e0', fontSize: '1.1rem', fontWeight: '500' }}>
                      {report.title}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NAACReportsPage;
